import { useContext } from 'react';

import { RoutesContext } from '@confluence/route-manager';

const MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS = ['mobileAppWithEditing'];
const MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS = [
	...MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS,
	'mobileAppWithCommenting',
];
const MOBILE_APP_PARENT_PRODUCT_QUERY_PARAMS = [
	...MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS,
	'mobileApp',
];

export const useIsMobileApp = () => {
	const { getQueryParams } = useContext(RoutesContext);
	const { parentProduct = '' } = getQueryParams();

	return {
		isMobileApp: MOBILE_APP_PARENT_PRODUCT_QUERY_PARAMS.includes(parentProduct as string),
		isMobileAppWithCommenting: MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS.includes(
			parentProduct as string,
		),
		isMobileAppWithEditing: MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS.includes(
			parentProduct as string,
		),
	};
};
